// Generates memorable RNG seeds for scripted HSH scenarios. The seed
// is read by the backend (Game.rng_seed) to drive deterministic deck
// shuffles, Fate rolls, and AI tiebreaks. Word pool is curated from
// HSH vocabulary so generated seeds look like the game, not a UUID.

const SEED_WORDS = [
    // Factions (Manual §1.2)
    'Deep', 'Stem', 'Hex', 'Dread', 'Honored', 'Seed',
    // Guest types (Manual §9)
    'Scientist', 'Vanguard', 'Thespian', 'Patron', 'Worshiper',
    'Seeker',
    // Amenities (Manual §3.3)
    'Casino', 'Theater', 'Bar', 'Altar', 'Menagerie', 'Observatory',
    // Action rooms + currency + iconic objects (Manual §4–§7)
    'Snohe', 'Ghost', 'Lodging', 'Research', 'Staff', 'Renovation',
    'Advertisement', 'Wheel', 'Wave', 'Fate', 'Relic', 'Chest',
    'Vendor', 'Mystery', 'Boss', 'Robot',
    // Lore / places (TName 144–148)
    'Zygnus', 'Meganism', 'Llolooloo', 'Megan',
];

function _pick(rng, list) {
    return list[Math.floor(rng() * list.length)];
}

export function generateReadableSeed(rng = Math.random) {
    // Two distinct words + a 1..9999 integer.
    const first = _pick(rng, SEED_WORDS);
    let second = _pick(rng, SEED_WORDS);
    // Guarantee distinct without a retry loop that could spin on a
    // one-word pool (defensive; the curated pool is long enough that
    // this almost never fires).
    if (second === first) {
        const idx = SEED_WORDS.indexOf(first);
        second = SEED_WORDS[(idx + 1) % SEED_WORDS.length];
    }
    const number = 1 + Math.floor(rng() * 9999);
    return `${first}-${second}-${number}`;
}

// Exported for tests; do not import in production code.
export const _SEED_WORDS_FOR_TEST = SEED_WORDS;
